var _style, _polygon, _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickLankaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 354 117",
    style: {
      enableBackground: "new 0 0 354 117"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_00000144326981859370320750000006881298301581335738_);}\r\n\t.st2{fill:url(#SVGID_00000013182664859444939560000003539263780564657033_);}\r\n\t.st3{fill:url(#SVGID_00000003073719117755429340000013589926183867456128_);}\r\n\t\r\n\t\t.st4{clip-path:url(#SVGID_00000150095258366445638280000017093842776646645154_);fill:url(#SVGID_00000105395627194702195110000007254258370821319574_);}\r\n\t\r\n\t\t.st5{clip-path:url(#SVGID_00000150095258366445638280000017093842776646645154_);fill:url(#SVGID_00000114793297624090056930000016398391654339977108_);}\r\n\t\r\n\t\t.st6{clip-path:url(#SVGID_00000150095258366445638280000017093842776646645154_);fill:url(#SVGID_00000150080973507548905540000000246727289570268604_);}\r\n\t\r\n\t\t.st7{clip-path:url(#SVGID_00000150095258366445638280000017093842776646645154_);fill:url(#SVGID_00000173135685623074845460000004705442059653523328_);}\r\n\t.st8{fill:url(#SVGID_00000143586039796305552950000009181210179426334609_);}\r\n\t.st9{fill:url(#SVGID_00000130629759888878031650000003678455529813327490_);}\r\n\t.st10{fill:url(#SVGID_00000153674731135568216380000015933235418985587360_);}\r\n\t.st11{fill:url(#SVGID_00000088821257136593155420000003230387211557438623_);}\r\n\t.st12{fill:url(#SVGID_00000161594669696804653450000004468527974534799516_);}\r\n\t.st13{fill:url(#SVGID_00000176036567012366953260000007537727956650814654_);}\r\n\t.st14{fill:url(#SVGID_00000083075493826924821120000001872355425975652228_);}\r\n\t.st15{fill:url(#SVGID_00000080200924256616175330000010204492353526807709_);}\r\n\t.st16{fill:url(#SVGID_00000058554495208837716760000004196357033361527426_);}\r\n\t.st17{fill:#BE1E2D;}\r\n\t.st18{fill:#A0C23A;}\r\n\t.st19{fill:url(#SVGID_00000181082736731623731070000018291092093471642257_);}\r\n\t.st20{fill:url(#SVGID_00000011737090000629023910000009615145079345417124_);}\r\n\t.st21{fill:url(#SVGID_00000129178083090908438110000006547879100510473407_);}\r\n\t.st22{fill:url(#SVGID_00000084522003337027968280000015486722182665275308_);}\r\n\t.st23{fill:url(#SVGID_00000095326806697531601480000002832073067827975045_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.4107,
    y1: 24.2427,
    x2: 37.2321,
    y2: 24.2427
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "36.2,22 35.4,26.5 37.2,22.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064349245517293828190000004594478415154476727_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.4678,
    y1: 55.8868,
    x2: 45.7701,
    y2: 26.4605
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F187B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064349245517293828190000004594478415154476727_)"
    },
    d: "M69,34C50.2,8.8,27,13.9,27,13.9 c22.6-1.2,35.2,16.2,35.2,16.2C77.7,50,75.7,68.1,73,77.3c-1.7,6.1-5.9,11.2-11.7,13.9c-2.3,1.1-5,1.8-8.1,1.9 c-5.3,0.1-9-2.5-11.4-5.2c-2.3-2.7-3.7-6-4.2-9.4c-1-6.5-0.3-14.5,2.8-20.9C45.1,48,43,37.6,43,37.6s-1.7-12.8-12-10.6 c-8.8,1.9-6.9,9.9-6.9,9.9c-3.1,1.8-2,5.4-2,5.4c-0.2-1.3,1.7-4.4,4.1-4.2c2.3,0.2,3.6-0.8,4-1.3c0.4-0.5,1.5-1.1,1.5-1.1 s3-1.5,3.4,4.3c0.4,5.8-4.7,9.2-4.7,9.2c-11.9,6.1-15.3,14.2-15.3,14.2c2.1-1.6,4.2-1.9,5.3-1.9c0.8,0,1.5,0,2.3-0.1 c10-1.3,14-5,15-6.2C33.2,60.7,34,68.9,34,68.9c0.1,3.6,0.6,6.7,1.4,9.4l0,0c0,0,0.1,0.2,0.2,0.6c1.2,3.9,2.9,6.8,4.5,8.8 c2.8,3.9,7.2,7.7,13.4,8.3c13.5,1.2,20.8-9.3,20.8-9.3S91.9,64.5,69,34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105388216863134757770000009404879519381441413_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.2913,
    y1: 21.9571,
    x2: 38.4744,
    y2: 21.9571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000105388216863134757770000009404879519381441413_)"
    },
    cx: 36.9,
    cy: 22,
    r: 1.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172422937811539426180000016025592126218346148_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3214,
    y1: 24.9987,
    x2: 39.9422,
    y2: 24.9987
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172422937811539426180000016025592126218346148_)"
    },
    points: "39.3,23.7 36.3,26.3 39.9,24.2  "
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000071533449178947427190000016102306907448374710_",
    d: "M69,34C50.2,8.8,27,13.9,27,13.9 c22.6-1.2,35.2,16.2,35.2,16.2C77.7,50,75.7,68.1,73,77.3c-1.4,4.9-4.4,9.2-8.6,12.1c0,0,0,0,0,0c-2.3,1.4-4.9,2.1-7.5,2.2 c-18,0.4-18.4-16.9-18.4-16.9c-0.1-0.7-0.1-1.7-0.1-2.6c0,0-0.8-4.5,3.4-16.6c4.2-12.2,0-22,0-22.1c-2.1-3.6-5.7-7.8-10.8-6.4 c-8.7,2.3-6.9,9.9-6.9,9.9c-3.1,1.8-2,5.4-2,5.4c-0.2-1.3,1.7-4.4,4.1-4.2c2.3,0.2,3.6-0.8,4-1.3c0.4-0.5,1.5-1.1,1.5-1.1 s3-1.5,3.4,4.3c0.2,2.5-0.7,4.5-1.7,6.1c-1,1.6-2.5,2.9-4.2,3.8c-11,6-14.1,13.6-14.1,13.6c2.1-1.6,4.2-1.9,5.3-1.9 c0.8,0,1.5,0,2.3-0.1c10-1.3,13.9-5,15-6.2C33.2,60.7,34,68.9,34,68.9c0.1,3.6,0.6,6.7,1.4,9.4l0,0c0,0,0.1,0.2,0.2,0.6 c1.2,3.9,2.9,6.8,4.5,8.8c1.6,2.2,3.7,4.4,6.3,6l0,0l0,0c2,1.2,4.4,2.1,7.1,2.3c13.5,1.2,20.8-9.3,20.8-9.3S91.9,64.5,69,34z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000062175755520376451750000011900856938469671609_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000071533449178947427190000016102306907448374710_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067204903834068407100000006925217345620512175_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.6571,
    y1: 50.8006,
    x2: 26.069,
    y2: 40.6056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6DE23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9EC31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062175755520376451750000011900856938469671609_)",
      fill: "url(#SVGID_00000067204903834068407100000006925217345620512175_)"
    },
    d: " M38.5,53.7c0.7-1.4,1.3-2.8,1.6-4.3c0.5-2.4,0.6-5.2-0.6-7.9c-1.9-4.2-4.1-5.5-5.5-5.9c-0.8-0.2-1.3-0.1-1.3-0.1 S20,52.5,19.4,53.1c-0.6,0.6-5.9,10.1-6,10.6c-0.1,0.5,3.9,1.7,4.9,1.7s7.1-0.4,7.1-0.4l1.9-0.2c0,0,6.5-3.9,10.3-9.7l0,0.1 C37.6,55.3,38,54.7,38.5,53.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120522419590398768470000017766389988470522555_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.0773,
    y1: 97.9284,
    x2: 38.803,
    y2: 2.9354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062175755520376451750000011900856938469671609_)",
      fill: "url(#SVGID_00000120522419590398768470000017766389988470522555_)"
    },
    d: " M37.7,55.1c0,0,7.4-9.6,4.1-21.8l4.6,3.5l1.5,5.7c0,0-3.4,11.2-3.4,12.3c0,1.1-0.9,7.2-1.7,8.3c-0.8,1.1-3.4,9.3-3.4,9.3 s1.5,5.3,1.8,6.8s2.7,3.8,3.3,5.9c0.6,2.1,3.4,4.5,6.4,4.7c3.1,0.2,5.6-1.1,8.8-1.7c3.2-0.6,7.1-2.3,9.3-7.6 c2.2-5.3,4.5-15.1,3.7-18.9C71.9,57.8,71.1,50.8,69,48c-2.1-2.8-6-11.2-7.3-13.2c-1.3-1.9-6.9-9.6-7.6-9.9 c-0.7-0.3-7.3-4.9-7.7-4.6c-0.4,0.3-3.3-2-6.4-2.9s-9.7-0.8-11.7-1.7c-2-0.8-6-3.6-4.3-5.1c1.7-1.5,8.7-6.2,18.2,0 s40.1,28.6,44.4,35.9c4.4,7.2,10.8,21,8.5,26.5S81.8,90.1,80.8,91.7c-1,1.5-15.3,5.2-16.1,5.6c-0.8,0.4-10.4,2.3-12.1,2.3 c-1.7,0-11.3-3.4-11.3-3.4l-8.6-20.6l0.4-9.5l1.7-7.6L37.7,55.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037650724372395268380000005548490258600040329_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.0437,
    y1: 58.8338,
    x2: 21.7464,
    y2: 39.1822
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9EC31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6921E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062175755520376451750000011900856938469671609_)",
      fill: "url(#SVGID_00000037650724372395268380000005548490258600040329_)"
    },
    d: " M32.7,35.4c0,0,7.3-0.2,5,13.1c0,0-1.6,9.6-18,12.3c0,0-2.7,0.6-4.6,2.5l1.4-10.7c0,0,7.4-6.1,7.8-6.4c0.4-0.3,6-7.6,6-7.6 L32.7,35.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048501398724507498990000002534450719009477505_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.2427,
    y1: 70.7132,
    x2: 15.3605,
    y2: 41.4077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F079AE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E1F63"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000062175755520376451750000011900856938469671609_)",
      fill: "url(#SVGID_00000048501398724507498990000002534450719009477505_)"
    },
    d: " M32.7,35.4c0,0,4,0.7,2.8,9.4c-0.6,4.7-3.2,9-7.3,11.4c-1.5,0.9-3.4,1.7-5.6,2.1C13.8,59.8,7.5,76.7,7.5,76.7l4.4-15.9l7.2-7.4 l14.3-13.5L32.7,35.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073693162945435130790000013746155790255193755_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.6513,
    y1: 23.7078,
    x2: 41.2331,
    y2: 23.7078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000073693162945435130790000013746155790255193755_)"
    },
    cx: 39.9,
    cy: 23.7,
    r: 1.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143593055468571975580000000887481678295061941_",
    gradientUnits: "userSpaceOnUse",
    x1: 56.5729,
    y1: 71.3052,
    x2: 55.8022,
    y2: 57.9459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143593055468571975580000000887481678295061941_)"
    },
    d: "M39.8,73.7c0,0,2.4,17.5,16.8,16.2 c2.6-0.2,5.1-1.2,7.1-2.9c4.8-3.9,12-13.6,8-36.2c0,0,4.5,32.3-14.1,36.6C57.6,87.4,44.7,92.1,39.8,73.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058573054472674303930000006187627393133341371_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.9685,
    y1: 100.5828,
    x2: 41.3561,
    y2: 56.2004
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6921E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE1E2D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000058573054472674303930000006187627393133341371_)"
    },
    d: "M34.3,59c0,0-4.6,10.9,1.8,25.5 c5.7,12.9,15.7,13.2,15.7,13.2s11.8,1.9,21.1-8c0,0-9.4,11.6-24.5,9.3S25,71.6,34.3,59z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103982973275037976330000014487936954490502291_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.2168,
    y1: 107.6915,
    x2: 31.6171,
    y2: 60.6714
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F9EC31"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6921E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103982973275037976330000014487936954490502291_)"
    },
    d: "M31.3,60.9c0,0-4.8,8.8-2.1,20.4 s10.2,17.3,10.2,17.3s6.9,6.1,22.3,2.5c0,0-15.8,7.5-29.1-3.7C32.6,97.4,17.3,83,31.3,60.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075880284736199186770000003930350671607336101_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.4054,
    y1: 102.0724,
    x2: 21.2529,
    y2: 64.262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D6DE23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9EC31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075880284736199186770000003930350671607336101_)"
    },
    d: "M28.2,61.8c0,0-14.6,21.5,6.1,39.2 C34.4,101,7.1,84.5,28.2,61.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076580093244664525050000013769968583119168384_",
    gradientUnits: "userSpaceOnUse",
    x1: 28.949,
    y1: 93.1845,
    x2: 18.4051,
    y2: 65.015
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076580093244664525050000013769968583119168384_)"
    },
    d: "M25.4,62.5c0,0-14.2,13.6-1.6,31.5 C23.8,94,6.1,76.3,25.4,62.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082326795410238640190000001293046139845180318_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.7552,
    y1: 83.6109,
    x2: 17.7262,
    y2: 63.8048
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#93D8F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0071BB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082326795410238640190000001293046139845180318_)"
    },
    d: "M20.9,63.2c0,0-10.3,10.6-4.5,21.6 C16.4,84.8,6.9,69.7,20.9,63.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170260090944880950860000015270303929217401984_",
    gradientUnits: "userSpaceOnUse",
    x1: -157.2538,
    y1: 156.141,
    x2: -146.3456,
    y2: 156.0361,
    gradientTransform: "matrix(-0.7112 0.7029 0.7029 0.7112 -91.8925 39.2365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EB008B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D91C5C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170260090944880950860000015270303929217401984_)"
    },
    d: "M121.3,47.9c1.3,1.3,4.3,0.5,6.6-1.8 c2.4-2.3,3.2-5.3,1.9-6.6c-1.3-1.3-4.3-0.5-6.6,1.8C120.9,43.7,120,46.6,121.3,47.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039835179765766182870000017830288755624106425_",
    gradientUnits: "userSpaceOnUse",
    x1: -152.3628,
    y1: 150.3011,
    x2: -146.6989,
    y2: 157.2586,
    gradientTransform: "matrix(-0.7112 0.7029 0.7029 0.7112 -91.8925 39.2365)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAAF40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9EC31"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039835179765766182870000017830288755624106425_)"
    },
    d: "M123.1,48.6c1.9-0.2,3.1-2.6,2.8-5.4 c-0.3-2.8-2.1-4.9-3.9-4.6c-1.9,0.2-3.1,2.6-2.8,5.4C119.5,46.7,121.3,48.8,123.1,48.6z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M123.2,41.3c0.5-0.5,1-0.9,1.5-1.3c0.6,0.8,1,1.9,1.1,3.1c0.3,2.8-0.9,5.2-2.8,5.4c-0.1,0-0.2,0-0.3,0 c0,0,0,0-0.1,0c-0.1,0-0.1,0-0.2,0c-0.5-0.1-0.9-0.3-1.2-0.6C120,46.6,120.9,43.7,123.2,41.3z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M96.9,46v25.4c0,1.8,0.2,3.1,0.6,4c0.4,0.9,1.1,1.7,2.3,2.4H88.9c1.2-0.6,1.9-1.6,2.2-3.1 c0.1-0.6,0.2-1.9,0.2-3.9v-22c0-2-0.1-3.3-0.2-3.9c-0.3-1.4-1.1-2.4-2.2-3.1h5.2c0.3,0,1,0,2-0.1c1,0,2.4,0,4.1,0h1.8 c2.8,0,5.1,0.4,6.9,1.2c1.8,0.8,3.2,2,4.2,3.5c1.1,1.5,1.6,3.1,1.6,4.8c0,2.8-1.2,5.3-3.5,7.3c-2.4,2-5.2,3-8.5,3 c-1.4,0-2.7-0.3-3.9-0.8c3-0.4,5.2-1.2,6.8-2.5c2-1.7,3.1-3.7,3.1-6c0-2.1-0.7-3.8-2.1-5c-1.4-1.2-3.3-1.8-5.8-1.8 C99.5,45.6,98.2,45.7,96.9,46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M125.4,51.5v20.9c0,1.8,0.1,2.9,0.3,3.4c0.2,0.5,0.8,1.2,1.8,1.9h-9.1c1-0.8,1.6-1.4,1.8-1.9 c0.2-0.5,0.3-1.7,0.3-3.4V58c0-1.8-0.1-2.9-0.3-3.4c-0.2-0.5-0.8-1.2-1.8-1.9h3.8C123.7,52.6,124.7,52.2,125.4,51.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M152.9,52.5v5.6c-1.9-1.8-4.1-2.6-6.8-2.6c-2.8,0-5,0.8-6.6,2.5c-1.7,1.6-2.5,3.8-2.5,6.6 c0,3,1.1,5.4,3.2,7.4c2.1,2,4.8,2.9,8,2.9c2.8,0,5.6-0.9,8.3-2.6l-3.2,5.3c-1.7,0.7-4,1-7,1c-4.3,0-7.9-1.2-10.7-3.6 c-2.8-2.4-4.2-5.5-4.2-9.2c0-3.9,1.5-7.2,4.5-9.9c2.8-2.6,6.5-3.9,11.1-3.9C148.9,51.9,150.9,52.1,152.9,52.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M158.3,41.8h3.8c1.5,0,2.6-0.3,3.2-1v31.6c0,1.8,0.1,2.9,0.3,3.4c0.2,0.5,0.8,1.2,1.8,1.9h-9.1 c1-0.8,1.6-1.4,1.8-1.9c0.2-0.5,0.3-1.7,0.3-3.4V47.2c0-1.8-0.1-2.9-0.3-3.4C159.9,43.2,159.3,42.6,158.3,41.8z M180.9,52.6 l-9.2,10.6c1.7,2.1,4,5.1,7,9c2,2.7,3.9,4.5,5.5,5.6c-1.6,0.1-3,0.2-4.3,0.2c-1.6,0-2.7-0.2-3.4-0.7c-0.4-0.3-2.1-2.4-4.9-6.3 c-0.8-1.1-1.7-2.3-2.6-3.6c-0.9-1.3-1.7-2.2-2.2-2.9c0,0-0.2-0.3-0.6-0.8l5-5.5c1.6-1.8,2.4-3.1,2.4-3.9c0-0.6-0.4-1.1-1.1-1.7 H180.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121975082500379689600000009079743042344814514_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.3873,
    y1: 59.7224,
    x2: 343.062,
    y2: 61.1792
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121975082500379689600000009079743042344814514_)"
    },
    d: "M207.8,48.8v24.5c2.5,0.4,4.9,0.6,7.4,0.6 c2,0,3.7-0.2,5.1-0.7c1.4-0.5,3-1.4,4.8-2.6l-2.9,7.2h-22.3c1.2-0.6,1.9-1.6,2.2-3.1c0.1-0.6,0.2-1.9,0.2-3.9v-22 c0-2-0.1-3.3-0.2-3.9c-0.3-1.4-1.1-2.4-2.2-3.1h10.4c-1.2,0.6-1.9,1.6-2.2,3.1C207.8,45.5,207.8,46.8,207.8,48.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027595733499355164750000005615596887361041061_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.3368,
    y1: 64.772,
    x2: 343.0115,
    y2: 66.2288
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027595733499355164750000005615596887361041061_)"
    },
    d: "M244.7,71.2v-7c-1.2,0.6-3.6,1.3-7,2.1 c-2.6,0.6-3.9,2-3.9,4.2c0,1.4,0.5,2.5,1.6,3.3c1,0.8,2.5,1.2,4.2,1.2c1.2,0,2.5-0.2,4.1-0.7l-3.2,4.1c-1,0.2-2,0.3-3,0.3 c-2.7,0-4.9-0.7-6.5-2.1c-1.9-1.7-2.8-3.7-2.8-6.1c0-2.5,1-4.3,3.1-5.5c1.3-0.7,3.7-1.4,7.2-2.1c2.4-0.4,4-0.9,4.9-1.5 c0.9-0.5,1.3-1.3,1.3-2.2c0-1.1-0.5-1.9-1.4-2.6c-1-0.6-2.2-1-3.8-1c-1.9,0-4.4,0.7-7.4,2.2l3.6-5.5c1.2-0.2,2.5-0.4,3.8-0.4 c4.5,0,7.6,1.2,9.1,3.5c0.5,0.8,0.8,1.5,1,2.3c0.1,0.8,0.2,2.2,0.2,4.4v7c0,1.6,0.1,2.6,0.2,3.1s0.5,1,1.1,1.4 c0.7,0.6,1.8,0.9,3.4,0.9l-2.4,3.6c-2.4-0.2-4.1-0.6-5-1.1c-1-0.6-1.6-1.4-1.9-2.5C244.8,73.9,244.7,72.8,244.7,71.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003801878607463501080000004501541051087177913_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.3441,
    y1: 64.0372,
    x2: 343.0188,
    y2: 65.4939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003801878607463501080000004501541051087177913_)"
    },
    d: "M263.5,51.5v4.6c2.5-2.8,5.1-4.2,8.1-4.2 c3.7,0,6.5,1.2,8.3,3.7c0.9,1.3,1.4,3.8,1.4,7.6v9.3c0,1.8,0.1,2.9,0.3,3.4c0.2,0.5,0.8,1.2,1.8,1.9h-9.1c1-0.8,1.6-1.4,1.8-2 c0.2-0.6,0.3-1.7,0.3-3.4v-8.7c0-2.6-0.4-4.4-1.1-5.4c-1.2-1.6-3-2.4-5.6-2.4c-2.3,0-4,0.8-5.1,2.3c-0.5,0.7-0.8,1.8-0.8,3.2v11 c0,1.8,0.1,2.9,0.3,3.4c0.2,0.5,0.8,1.2,1.8,1.9h-9.1c1-0.8,1.6-1.4,1.8-1.9c0.2-0.5,0.3-1.7,0.3-3.4V58c0-1.8-0.1-2.9-0.3-3.4 c-0.2-0.5-0.8-1.2-1.8-1.9h3.5C261.8,52.6,262.9,52.2,263.5,51.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085971537849417857820000015192866677746533523_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.401,
    y1: 58.3473,
    x2: 343.0757,
    y2: 59.804
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085971537849417857820000015192866677746533523_)"
    },
    d: "M287.3,41.8h3.8c1.5,0,2.6-0.3,3.2-1v31.6 c0,1.8,0.1,2.9,0.3,3.4c0.2,0.5,0.8,1.2,1.8,1.9h-9.1c1-0.8,1.6-1.4,1.8-1.9c0.2-0.5,0.3-1.7,0.3-3.4V47.2c0-1.8-0.1-2.9-0.3-3.4 C288.9,43.2,288.3,42.6,287.3,41.8z M309.9,52.6l-9.2,10.6c1.7,2.1,4,5.1,7,9c2,2.7,3.9,4.5,5.5,5.6c-1.6,0.1-3,0.2-4.3,0.2 c-1.6,0-2.7-0.2-3.4-0.7c-0.4-0.3-2.1-2.4-4.9-6.3c-0.8-1.1-1.7-2.3-2.6-3.6c-1-1.3-1.7-2.2-2.2-2.9c0,0-0.2-0.3-0.6-0.8l5-5.5 c1.6-1.8,2.4-3.1,2.4-3.9c0-0.6-0.4-1.1-1.1-1.7H309.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054976478144713180170000010153064163494877062_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.3454,
    y1: 63.9137,
    x2: 343.0201,
    y2: 65.3704
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00ADEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2E3191"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054976478144713180170000010153064163494877062_)"
    },
    d: "M330.6,71.2v-7c-1.2,0.6-3.6,1.3-7,2.1 c-2.6,0.6-3.9,2-3.9,4.2c0,1.4,0.5,2.5,1.6,3.3c1,0.8,2.5,1.2,4.2,1.2c1.2,0,2.5-0.2,4.1-0.7l-3.2,4.1c-1,0.2-2,0.3-3,0.3 c-2.7,0-4.9-0.7-6.5-2.1c-1.9-1.7-2.8-3.7-2.8-6.1c0-2.5,1-4.3,3.1-5.5c1.3-0.7,3.7-1.4,7.2-2.1c2.4-0.4,4-0.9,4.9-1.5 c0.9-0.5,1.3-1.3,1.3-2.2c0-1.1-0.5-1.9-1.5-2.6c-1-0.6-2.2-1-3.8-1c-1.9,0-4.4,0.7-7.4,2.2l3.6-5.5c1.2-0.2,2.5-0.4,3.8-0.4 c4.5,0,7.6,1.2,9.1,3.5c0.5,0.8,0.8,1.5,1,2.3c0.1,0.8,0.2,2.2,0.2,4.4v7c0,1.6,0.1,2.6,0.2,3.1c0.2,0.5,0.5,1,1.1,1.4 c0.7,0.6,1.8,0.9,3.4,0.9l-2.4,3.6c-2.4-0.2-4.1-0.6-5-1.1c-1-0.6-1.6-1.4-1.9-2.5C330.6,73.9,330.6,72.8,330.6,71.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickLankaLogo);
export default __webpack_public_path__ + "static/media/pick-lanka-logo.8e4eb39a337ada0006254aacffaf6933.svg";
export { ForwardRef as ReactComponent };